import {
  Button,
  Link,
  makeStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import React from 'react';
import { QKey, useAnswerContext } from '../../../context';
export interface IBaseInsightTextInterface {
  isHighlihted: boolean;
  text: string;
}
export interface IBaseInsightInterface {
  onNext: () => void;
  onBack: () => void;
  nextText: IBaseInsightTextInterface;
  animatedImage?: JSX.Element;
  lines?: IBaseInsightTextInterface[];
  cite: string;
  addInfo?: boolean;
  info?: string;
  href: string;
  progressMain: string;
  questionKey: QKey;
}

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('md')]: {
      padding: '0px 13px 0px 0px',
    },
    [theme.breakpoints.up('md')]: {
      padding: '24px 13px 0px 280px',
    },
  },
  insight: {
    fontWeight: 500,
    color: 'rgb(95,99,104)',
    lineHeight: '52px',
    margin: 0,
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
      letterSpacing: 0.31,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 18,
      letterSpacing: 0.4,
    },
  },
  body: {
    fontWeight: 400,
    color: 'rgb(32,33,36)',
    margin: 0,
    [theme.breakpoints.down('md')]: {
      fontSize: 24,
      lineHeight: '32px',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 34,
      letterSpacing: -0.4,
      lineHeight: '52px',
    },
  },
  button: {
    background: '#e8f0fe',
    color: '#1967d2',
    '&:hover': {
      background: '#e8f0fe',
    },
    [theme.breakpoints.down('md')]: {
      marginRight: 20,
    },
    [theme.breakpoints.up('md')]: {
      marginRight: 50,
    },
  },
  footer: {
    margin: '20px 0 30px',
    fontSize: 12,
    letterSpacing: -0.06,
    lineHeight: '18px',
    display: 'block',
    fontWeight: 400,
    fontStyle: 'italic',
    color: 'rgb(95,99,104)',
  },
  oval: {
    fill: '#4285F4',
    '&:hover': {
      fill: '#165abc',
    },
    transition: 'background 0.2s',
  },
  infoStyle: {
    marginTop: 40,
    textAlign: 'left',
    lineHeight: '30px',
    fontFamily: 'Google Sans',
    fontSize: 18,
    color: '#5F6368',
  },
}));

export const BaseInsight: React.FC<IBaseInsightInterface> = ({
  onNext,
  nextText,
  lines,
  cite,
  animatedImage,
  href,
  onBack,
  info,
  progressMain,
  questionKey,
}) => {
  const { root, body, insight, footer, button, infoStyle } = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));
  const { values } = useAnswerContext();
  const isFlow2 = false;

  return (
    <div className={root} style={{ paddingRight: matches ? 0 : undefined }}>
      <h3 className={insight}>Insights: </h3>
      <p
        className={body}
        style={{
          marginRight:
          questionKey === 'q6'
              ? 20
              : questionKey === 'q1' && isFlow2
              ? 70
              : questionKey === 'q2' && isFlow2
              ? 25
              : undefined,
        }}
      >
        {Array.isArray(lines) ? (
          <>
            {lines.map((t) => (
              <span style={{ color: t.isHighlihted ? progressMain : '' }}>
                {t.text}
              </span>
            ))}
          </>
        ) : ''}
      </p>
      <cite className={footer}>
        {href ? (
          <span
            style={{
              color: 'rgb(95,99,104)',
              fontStyle: 'normal',
            }}
          >
            Source:
            <Link
              href={href}
              target="blank"
              underline="none"
              style={{
                color: 'rgb(95,99,104)',
                fontStyle: 'normal',
                textDecoration: 'underline',
                marginLeft: 5,
              }}
            >
              {cite}
            </Link>
          </span>
        ) : (
          cite
        )}
      </cite>
      {animatedImage ? (
        <div
          style={{
            position: 'relative',
            width: '100%',
            height: 250,
            maxWidth: 350,
            // transform: 'scale(0.7)',
            margin: '0 auto',
          }}
        >
          {animatedImage}
        </div>
      ) : null}
      <div
        style={{
          display: 'flex',
          justifyContent: matches ? 'center' : 'flex-start',
        }}
      >
        <Button
          color="primary"
          variant="contained"
          onClick={onBack}
          className={button}
        >
          Back
        </Button>
        <Button color="primary" variant="contained" onClick={onNext}>
          {nextText.text}
        </Button>
      </div>
      {!info ? null : <div className={infoStyle}>{info}</div>}
    </div>
  );
};
